import { render, staticRenderFns } from "./EMelderComponentMeldungenCommunicationLeftElement.vue?vue&type=template&id=0ea8df9c&scoped=true"
import script from "./EMelderComponentMeldungenCommunicationLeftElement.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenCommunicationLeftElement.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentMeldungenCommunicationLeftElement.vue?vue&type=style&index=0&id=0ea8df9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8df9c",
  null
  
)

export default component.exports